import { requestsRepo } from '@/constants/providers';
import { FilterType, SortDirection, StatusValue } from '@/shared';
import { useInfiniteQuery } from '@tanstack/react-query';
import { DateRange } from 'react-day-picker';
import { mapRequestFilters } from '../mappers';
import { RequestsKey } from './types';
import { OrganizationContext } from '@/components/OrganizationProvider/OrganizationProvider';
import { useContext } from 'react';

type GetRequestsInfiniteProps = {
  onlyActiveRequests: boolean;
  activeTypologies: string[];
  filterBy?: FilterType;
  filter?: string;
  sortBy?: string;
  sortOrder?: SortDirection;
  dateRange?: DateRange;
  status?: StatusValue[];
  rowsPerPage?: number;
};

export const useGetRequestsInfinite = ({
  onlyActiveRequests,
  activeTypologies,
  filterBy,
  filter,
  sortBy,
  sortOrder,
  dateRange,
  status,
  rowsPerPage = 5,
}: GetRequestsInfiniteProps) => {
  const filters = mapRequestFilters({
    onlyActiveRequests,
    activeTypologies,
    filter,
    filterBy,
    dateRange,
    status,
  });
  const { organizationId } = useContext(OrganizationContext);
  return useInfiniteQuery({
    initialPageParam: 1,
    queryKey: [...RequestsKey.LIST(filters, sortBy, sortOrder), organizationId],
    queryFn: ({ pageParam }) =>
      requestsRepo.getRequests(
        filters,
        sortBy,
        sortOrder,
        pageParam,
        rowsPerPage,
      ),
    getNextPageParam: (lastPage, allPages) => {
      return lastPage.length < rowsPerPage ? undefined : allPages.length + 1;
    },
  });
};
